import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import EnquiryForm from "./enquiry/enquiryForm";
import ContentBlocks from "./contentblocks/ContentBlocks";
import { Link, Route, Routes } from "react-router-dom";
import PanelDetails from "./landingPage/PanelBanner/PanelDetails";
import Signup from "./auth/SignIn/Signup";
import Login from "./auth/SignIn/Login";
import ForgotPassword from "./auth/ForgotPassword";
import ChangePassword from "./auth/ChangePassword";
import RequireAdmin from "./auth/RequireAdmin";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import LandingPage from "./landingPage/LandingPage";

function App() {
  return (
    <div>
      <NavBar />
      <Routes>
        <Route
          element={
            <>
              <Outlet />
            </>
          }
        />
        <Route path="/" element={<LandingPage />} />
        <Route path="/enquiry" element={<EnquiryForm />} />
        <Route
          path="/content-blocks"
          element={
            <RequireAdmin>
              <ContentBlocks />
            </RequireAdmin>
          }
        />
        <Route path="/panel-info" element={<PanelDetails />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        {/* <Route
          path="/"
          element={
            <>
              <Navbar />
              <LandingPage />
              <Footer />
            </>
          }
        />
        <Route
          path="/enquiry"
          element={
            <>
              <Navbar />
              <EnquiryForm />
              <Footer />
            </>
          }
        />
        <Route
          path="/content-blocks"
          element={
            <>
              <Navbar />
              <ContentBlocks />
              <Footer />           
            </>
          }
        />
        <Route
          path="/panel-info"
          element={
            <>
              <Navbar />
              <Panel />
              <Footer />           
            </>
          }
        /> */}
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
